export default "__VITE_ASSET__D0uS9Tk$__"